<template>
  <div>
    <!-- 抖音号ID、排除指定抖音号、指定抖音号 -->
    <div v-if="formKey === 'dou_yin_ids' || formKey === 'exclude_aweme_ids' || formKey === 'aweme_ids'">
      <div class="flex items-center">
        <el-button v-if="!formItem.isPreview" type="primary" @click="openDouYinAccount(formItem)">选择抖音号</el-button>
        <i v-if="Object.keys(formItem.value || {}).length && !formItem.isPreview" class="el-icon-success app-check-icon-success ml-10" />
      </div>
      <div v-if="formItem.isPreview">-</div>
      <el-dialog
        title="抖音号配置"
        :visible.sync="formItem.is_open"
        :close-on-click-modal="false"
        :append-to-body="true"
        :modal-append-to-body="true"
        width="800px"
      >
        <dou-yin-account v-if="formItem.is_open" ref="dou-yin-account-ref" :form-item="formItem" :init-ops="initOps" />
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="formItem.is_open = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="confirmDouYinAccount(formItem, formKey)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 小游戏链接配置 -->
    <div v-if="formKey === 'byte_dance_games'">
      <el-button v-if="!formItem.isPreview" type="primary" @click="formItem.is_open = true">选择小游戏链接</el-button>
      <div v-if="formItem.value.result_value.length">
        <div>
          <span class="mr-20">{{ formItem.value.result_value[0].advertiser_id }}</span>
          <span class="mr-20">{{ formItem.value.result_value[0].channel_alias }}</span>
          <span>{{ getOptionByValue(formItem.value.result_value[0].options, formItem.value.result_value[0].value)?.label || '-' }}</span>
        </div>
      </div>
      <el-dialog
        title="小游戏链接配置"
        :visible.sync="formItem.is_open"
        :close-on-click-modal="false"
        :append-to-body="true"
        :modal-append-to-body="true"
        width="800px"
      >
        <byte-dance-games v-if="formItem.is_open" ref="byte-dance-games-ref" :form-item="formItem" :init-ops="initOps" />
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="formItem.is_open = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="byteDanceGamesConfirm(formItem)">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { component_props } from '@/views/fusion/investment/intelligence-create/components/main-view/components/step-form/model/props';
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';

export default {
  components: {
    'byte-dance-games': () => import('./components/byte-dance-games/index.vue'),
    'dou-yin-account': () => import('./components/dou-yin-account/index.vue'),
  },
  mixins: [data_sharing_mixin],
  props: {
    ...component_props,
  },
  methods: {
    /**
     * 根据值获取选项
     * @param {Object[]} options 选项
     * @param {number|string} val 值
     * @returns {Object}
     */
    getOptionByValue(options, val) {
      return options.find(({ value }) => value === val) || {};
    },
    /**
     * 小游戏链接配置弹窗确认
     * @param form_item 表单项
     * @returns {void}
     */
    byteDanceGamesConfirm(form_item) {
      const result = this.$refs['byte-dance-games-ref']?.getAssignResult() || [];
      const is_valid = result.length && result.every(({ value }) => value);
      if (is_valid) {
        form_item.value.result_value = result;
        form_item.is_open = false;
        this.$parent.$parent.$parent.validateField('byte_dance_games.value');
      } else {
        this.$message.warning('请填写完整所有配置');
      }
    },
    /**
     * 打开抖音号配置
     * @param form_item 表单项
     * @returns {void}
     */
    openDouYinAccount(form_item) {
      form_item.assignSelection = JSON.parse(JSON.stringify(form_item.value));
      form_item.is_open = true;
    },
    /**
     * 抖音号配置弹窗确认
     * @param form_item 表单项
     * @param form_key 表单键
     * @returns {void}
     */
    confirmDouYinAccount(form_item, form_key) {
      const result = JSON.parse(JSON.stringify(form_item.assignSelection));
      const { config: { init_ops: { advertiser_ids }}} = this.local_sharing_data.getFormContext();
      const is_valid = advertiser_ids.every(advertiser_id => result[advertiser_id]?.length);
      const is_exclude_aweme_ids = form_key === 'exclude_aweme_ids';
      if (is_exclude_aweme_ids || is_valid) {
        form_item.value = JSON.parse(JSON.stringify(form_item.assignSelection));
        form_item.backup_value = JSON.parse(JSON.stringify(form_item.assignSelection));
        form_item.is_open = false;
        form_item?.on?.change?.(form_item.value);
        this.$parent.$parent.$parent.validateField(`${form_key}.value`);
      } else {
        this.$message.warning('请填写完整所有配置');
      }
    },
  },
};
</script>
